import React, { useState } from 'react';
import { Button } from '@mui/material';
import { Modal } from 'framework/ui/ui-builder';
import ResubmitCandidateApplicationModalForm from 'domain/recruiting/candidate/applications/resubmit/ResubmitCandidateApplicationModalForm';
import { useAuthorization } from 'framework/authorization';
import GLOBAL_RECRUITING_APPLICATION_CREATE from '../constants';

const ResubmitCandidateApplicationButton = ({ applicationId }: { applicationId: number }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const { isGranted } = useAuthorization();

  const isButtonVisible = isGranted(GLOBAL_RECRUITING_APPLICATION_CREATE);

  const closeModal = () => {
    setModalOpen(false);
  };

  return isButtonVisible ? (
    <>
      <Button
        variant="outlined"
        size="small"
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          setModalOpen(true);
          (e.target as HTMLElement).blur();
        }}
      >
        Recreate Application
      </Button>
      <Modal
        backdrop="static"
        isOpen={modalOpen}
        title="Resubmit Application for an existing candidate"
        onToggle={closeModal}
        hasCancelButton={false}
        className="qualification-modal"
        modalSize="sm"
      >
        <ResubmitCandidateApplicationModalForm
          applicationId={applicationId}
          closeModal={closeModal}
          modalOpen={modalOpen}
        />
      </Modal>
    </>
  ) : null;
};

export default ResubmitCandidateApplicationButton;
